import { useQuery } from '@tanstack/react-query';

import { individualsService, useToast } from '@aslanpay/portal-common-lib';

const useCheckNonSalariedWorkers = (companyId?: string) => {
  const toast = useToast();

  const enabled = !!companyId && companyId !== '';

  return useQuery<boolean, Error>(
    ['checkNonSalariedWorkers', companyId, enabled],
    async () => {
      const response = await individualsService.fetchIndividuals({
        role: ['EMPLOYEE'],
        companyId: [companyId as string],
        page: 0,
        size: 999999, // Get all employees to check for non-salaried status
      });

      // Check if any employee has salaried: false or undefined (non-salaried workers)
      const hasNonSalariedWorkers = response.list.some(
        (employee) => employee.salaried === false || employee.salaried === undefined
      );

      return hasNonSalariedWorkers;
    },
    {
      enabled,
      staleTime: 0, // Don't cache when disabled
      cacheTime: 0, // Don't cache when disabled
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to check for non-salaried workers. Please try again.',
        });
      },
    }
  );
};

export default useCheckNonSalariedWorkers;
